import React from "react";
import { useTranslation } from 'react-i18next';
import { useAdminSimulate } from "@/providers/AdminSimulateProvider";
import { Button } from "@/components/ui/button";
import { X, AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

export function AdminSimulateBanner() {
  console.log('[AdminSimulateBanner] Rendering');
  const { t } = useTranslation();
  console.log('[AdminSimulateBanner] useTranslation hook called successfully');
  const { isSimulating, simulatedUsername, simulatedUserId, stopSimulation } = useAdminSimulate();

  if (!isSimulating) {
    return null;
  }

  return (
    <Alert className="rounded-none border-0 border-b bg-yellow-500 text-yellow-950">
      <AlertCircle className="h-4 w-4" />
      <AlertDescription className="flex items-center justify-between">
        <span className="font-semibold">
          Admin Mode: Simulating user {simulatedUsername || simulatedUserId}
        </span>
        <Button
          size="sm"
          variant="outline"
          onClick={stopSimulation}
          className="ml-4 bg-yellow-950 text-yellow-500 hover:bg-yellow-900"
        >
          <X className="h-4 w-4 mr-1" />{t('ui.text.exit_simulation')}</Button>
      </AlertDescription>
    </Alert>
  );
}
